<template>
  <card-block>
    <spinner-block v-model="dataProgress">
      <template v-if="data">
        <card-header>
          <router-link :to="{name: 'promocode.list'}">Промокоды</router-link><!--
                    -->:
          <span class="text-secondary">#{{ data.id }}</span>
          {{ data.code }}
        </card-header>
        <tab-list>
          <tab-link to="promocode.detail">Основные данные</tab-link>
          <tab-link to="promocode.promocode-use" v-if="can('module.promocode.view')">Использование</tab-link>
        </tab-list>
        <card-body>
          <router-view :key="id" :data="data" @change="getData"></router-view>
        </card-body>
      </template>
    </spinner-block>
  </card-block>
</template>

<script>
export default {
  data: function () {
    return {
      data: null,
      dataProgress: true,
    }
  },
  props: {},
  computed: {
    id() {
      return this.$route.params.id;
    }
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      if (this.id) {
        axiosGetValue('/api/admin/promocode/get', {id: this.id}, e => this.data = e, e => this.dataProgress = e)
      }
    },
  },
}
</script>
